const DECIMALS_ABI = [
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export const decimalsSelector = (address?: `0x${string}`) =>
  ({
    abi: DECIMALS_ABI,
    address,
    functionName: "decimals",
    enabled: !!address,
  } as const);

const ALLOWANCE_ABI = [
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

/**
 *
 * @param address
 * @param owner
 * @param spender
 * @returns apply convertWithDecimals to useContractRead result
 */
export const allowanceSelector = (
  address?: `0x${string}`,
  owner?: `0x${string}`,
  spender?: `0x${string}`,
) =>
  address && owner && spender
    ? ({
        abi: ALLOWANCE_ABI,
        address,
        functionName: "allowance",
        args: [owner, spender],
      } as const)
    : ({
        abi: ALLOWANCE_ABI,
        address,
        functionName: "allowance",
        enabled: false,
      } as const);
